import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { Icon } from "rhombus-react";

import { noop } from "utils/common";
import useSelectAssets from "hooks/useSelectAssets";
import { Assets } from "reducers/Assets";

export default function ImageInput(props){
	const dispatch = useDispatch();
	const {
		onSelectAssets,
		selectedIds,
		inputPrompt,
		modalTitle,
		accept,
	} = props;

	const {
		SelectionModal,
		openSelectionModal,
	} = useSelectAssets(
		{
			title: modalTitle,
		},
		() => {
			dispatch(Assets.setSort("lastModified", "DESC"));
			dispatch(Assets.updateColumnFilter("assetType", { params: ["Image"]}));

			if(selectedIds.length){
				// This removes already selected images from the select Assets grid
				dispatch(Assets.updateColumnFilter("id", { params: selectedIds }));
			}
		}
	);

	return (
		<>
			<a className="image-input" onClick={() => {
				openSelectionModal("image", onSelectAssets);
			}}>
				{ inputPrompt }
			</a>
			{SelectionModal && <SelectionModal multiple accept = {accept} />}
		</>
	);
}

ImageInput.displayName = "ImageInput";

ImageInput.propTypes = {
	onSelectAssets: PropTypes.func,
	selectedIds: PropTypes.array,
	modalTitle: PropTypes.string,
	accept: PropTypes.string,
	inputPrompt: PropTypes.node,
};

ImageInput.defaultProps = {
	onSelectAssets: noop,
	selectedIds: [],
	modalTitle: "Select Image(s)",
	accept: "*",
	inputPrompt: (
		<>
			<Icon name="assetImage" />
			Upload /<br />
			Select Images
		</>
	),
};
